import { render, staticRenderFns } from "./poaAssignments.vue?vue&type=template&id=016cb819&scoped=true&"
import script from "./poaAssignments.vue?vue&type=script&lang=js&"
export * from "./poaAssignments.vue?vue&type=script&lang=js&"
import style0 from "./poaAssignments.vue?vue&type=style&index=0&id=016cb819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cb819",
  null
  
)

export default component.exports